var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container discussion-admin-page" },
    [
      _c(
        "div",
        { staticClass: "page-heading" },
        [
          _vm._m(0),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-refresh", loading: _vm.loading },
              on: { click: _vm.reload },
            },
            [_vm._v("重新載入")]
          ),
        ],
        1
      ),
      _c("el-alert", {
        staticClass: "permission-alert",
        attrs: {
          title:
            "本期僅 ITA-DEV 與 ITA-ADMIN 可使用；未來若開放旅行社，將由集中式權限政策調整。",
          type: "info",
          closable: false,
          "show-icon": "",
        },
      }),
      _vm.featureDisabled
        ? _c("el-alert", {
            staticClass: "permission-alert",
            attrs: {
              type: "warning",
              title: "專區已關閉",
              description:
                "領隊導遊專區目前已關閉，隱藏、復原與檢舉處理等寫操作已停用；如需開放，請聯絡系統管理員。",
              closable: false,
              "show-icon": "",
            },
          })
        : _vm._e(),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.reload },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "文章與留言", name: "posts" } },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true, model: _vm.postQuery },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "關鍵字" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "100", clearable: "" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.searchPosts($event)
                          },
                        },
                        model: {
                          value: _vm.postQuery.keyword,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.postQuery,
                              "keyword",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "postQuery.keyword",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "顯示狀態" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部" },
                          model: {
                            value: _vm.postQuery.visibility,
                            callback: function ($$v) {
                              _vm.$set(_vm.postQuery, "visibility", $$v)
                            },
                            expression: "postQuery.visibility",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "公開", value: "visible" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已隱藏", value: "hidden" },
                          }),
                          _c("el-option", {
                            attrs: { label: "草稿", value: "draft" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-search",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.searchPosts },
                        },
                        [_vm._v("查詢")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.loadError
                ? _c("el-alert", {
                    attrs: {
                      type: "error",
                      title: _vm.loadError,
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    data: _vm.posts,
                    border: "",
                    stripe: "",
                    "empty-text": "尚無討論文章",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      label: "標題",
                      "min-width": "240",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "authorName",
                      label: "作者",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "category",
                      label: "分類",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "commentCount",
                      label: "留言",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "reportCount",
                      label: "檢舉",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "hiddenReason",
                      label: "隱藏原因",
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "updatedAt",
                      label: "更新時間",
                      width: "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "狀態", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: { type: _vm.postStatusType(scope.row) },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.postStatusLabel(scope.row)) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "270",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openPost(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openComments(scope.row)
                                  },
                                },
                              },
                              [_vm._v("留言")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: scope.row.hidden
                                    ? "success"
                                    : "warning",
                                  disabled: _vm.featureDisabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeVisibility(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.hidden ? "復原" : "隱藏") +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.postTotal > 0,
                    expression: "postTotal > 0",
                  },
                ],
                attrs: {
                  total: _vm.postTotal,
                  page: _vm.postQuery.page,
                  limit: _vm.postQuery.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.postQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.postQuery, "limit", $event)
                  },
                  pagination: _vm.fetchPosts,
                },
              }),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "檢舉處理", name: "reports" } },
            [
              _c(
                "el-form",
                { attrs: { inline: true, model: _vm.reportQuery } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "處理狀態" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部" },
                          on: { change: _vm.searchReports },
                          model: {
                            value: _vm.reportQuery.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.reportQuery, "status", $$v)
                            },
                            expression: "reportQuery.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "待處理", value: "pending" },
                          }),
                          _c("el-option", {
                            attrs: { label: "已處理", value: "resolved" },
                          }),
                          _c("el-option", {
                            attrs: { label: "不成立", value: "dismissed" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.loadError
                ? _c("el-alert", {
                    attrs: {
                      type: "error",
                      title: _vm.loadError,
                      closable: false,
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    data: _vm.reports,
                    border: "",
                    stripe: "",
                    "empty-text": "尚無檢舉資料",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "對象", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.targetTypeLabel(scope.row.targetType))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "targetSummary",
                      label: "內容摘要",
                      "min-width": "230",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "reason",
                      label: "檢舉原因",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "resolutionNote",
                      label: "處理說明",
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "reportedAt",
                      label: "檢舉時間",
                      width: "170",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "狀態", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.reportStatusLabel(scope.row.status))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "180",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            String(scope.row.status).toLowerCase() === "pending"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resolveReport(
                                          scope.row,
                                          "resolved"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("成立")]
                                )
                              : _vm._e(),
                            String(scope.row.status).toLowerCase() === "pending"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      disabled: _vm.featureDisabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resolveReport(
                                          scope.row,
                                          "dismissed"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("不成立")]
                                )
                              : _c("span", [_vm._v("已完成")]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.reportTotal > 0,
                    expression: "reportTotal > 0",
                  },
                ],
                attrs: {
                  total: _vm.reportTotal,
                  page: _vm.reportQuery.page,
                  limit: _vm.reportQuery.limit,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.reportQuery, "page", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.reportQuery, "limit", $event)
                  },
                  pagination: _vm.fetchReports,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "文章內容",
            visible: _vm.postDialog.visible,
            width: "760px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.postDialog, "visible", $event)
            },
          },
        },
        [
          _vm.postDialog.post
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "標題", span: 2 } },
                    [_vm._v(_vm._s(_vm.postDialog.post.title))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "作者" } }, [
                    _vm._v(_vm._s(_vm.postDialog.post.authorName)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "狀態" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "mini",
                            type: _vm.postStatusType(_vm.postDialog.post),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.postStatusLabel(_vm.postDialog.post)) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-descriptions-item", { attrs: { label: "分類" } }, [
                    _vm._v(_vm._s(_vm.postDialog.post.category || "無")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "地區" } }, [
                    _vm._v(_vm._s(_vm.postDialog.post.region || "無")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "標籤", span: 2 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            (_vm.postDialog.post.tags || []).join("、") || "無"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "參考連結", span: 2 } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.postDialog.post.referenceUrl || "無") +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "內容", span: 2 } },
                    [
                      _c("div", { staticClass: "post-content" }, [
                        _vm._v(_vm._s(_vm.postDialog.post.content)),
                      ]),
                    ]
                  ),
                  _vm.postDialog.post.hidden
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "隱藏原因", span: 2 } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.postDialog.post.hiddenReason) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "互動", span: 2 } },
                    [
                      _vm._v(
                        " 瀏覽 " +
                          _vm._s(_vm.postDialog.post.viewCount || 0) +
                          "／按讚 " +
                          _vm._s(_vm.postDialog.post.likeCount || 0) +
                          "／收藏 " +
                          _vm._s(_vm.postDialog.post.bookmarkCount || 0) +
                          "／留言 " +
                          _vm._s(_vm.postDialog.post.commentCount || 0) +
                          "／檢舉 " +
                          _vm._s(_vm.postDialog.post.reportCount || 0) +
                          " "
                      ),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "建立時間" } }, [
                    _vm._v(_vm._s(_vm.postDialog.post.createdAt)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "更新時間" } }, [
                    _vm._v(_vm._s(_vm.postDialog.post.updatedAt)),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.postDialog.post
            ? _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: _vm.postDialog.post.hidden
                          ? "success"
                          : "warning",
                        disabled: _vm.featureDisabled,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeVisibility(_vm.postDialog.post)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.postDialog.post.hidden ? "復原" : "隱藏") +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.postDialog.visible = false
                        },
                      },
                    },
                    [_vm._v("關閉")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.commentDialog.post
              ? "留言管理｜" + _vm.commentDialog.post.title
              : "留言管理",
            visible: _vm.commentDialog.visible,
            width: "760px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.commentDialog, "visible", $event)
            },
          },
        },
        [
          _vm.commentDialog.error
            ? _c("el-alert", {
                attrs: {
                  type: "error",
                  title: _vm.commentDialog.error,
                  closable: false,
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.commentDialog.loading,
                  expression: "commentDialog.loading",
                },
              ],
              attrs: {
                data: _vm.commentDialog.items,
                border: "",
                stripe: "",
                "empty-text": "尚無留言",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "authorName", label: "作者", width: "130" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "content",
                  label: "留言內容",
                  "min-width": "300",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hiddenReason",
                  label: "隱藏原因",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "createdAt", label: "留言時間", width: "170" },
              }),
              _c("el-table-column", {
                attrs: { label: "狀態", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.hidden ? "danger" : "success",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.hidden ? "已隱藏" : "公開") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: scope.row.hidden ? "success" : "warning",
                              disabled: _vm.featureDisabled,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeCommentVisibility(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.hidden ? "復原" : "隱藏") +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.commentDialog.total > 0,
                expression: "commentDialog.total > 0",
              },
            ],
            attrs: {
              total: _vm.commentDialog.total,
              page: _vm.commentDialog.query.page,
              limit: _vm.commentDialog.query.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.commentDialog.query, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.commentDialog.query, "limit", $event)
              },
              pagination: _vm.fetchComments,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("交流討論管理")]),
      _c("p", [_vm._v("查看內容、隱藏或復原文章，並處理會員檢舉。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }